import request from '@/utils/request';
export function contractList(data) {
  return request.post('admin/contract/list', data);
}
export function addContract(data) {
  data.appendix = JSON.stringify(data.appendix);
  return request.post('admin/contract/store', data);
}
export function editContract(data) {
  data.appendix = JSON.stringify(data.appendix);
  return request.post('admin/contract/edit', data);
}
export function delContract(data) {
  return request.post('admin/contract/delete', data);
}
export function contractInfo(data) {
  return request.post('admin/contract/detail', data);
}
export const typeList = [{
  name: '保险公司合同',
  id: 1
}, {
  name: '中介机构合同',
  id: 2
}, {
  name: '合作客户合同',
  id: 3
}, {
  name: '其他合同类型',
  id: 4
}];
export const statusList = [{
  name: '待生效',
  id: 0
}, {
  name: '生效中',
  id: 1
}, {
  name: '已中止',
  id: 2
}, {
  name: '已失效',
  id: 3
}];
export function contractPlanList(data) {
  return request.post('admin/contract-plan/list', data);
}
export function addContractPlan(data) {
  return request.post('admin/contract-plan/store', data);
}
export function editContractPlan(data) {
  return request.post('admin/contract-plan/edit', data);
}
export function contractPlanInfo(data) {
  return request.post('admin/contract-plan/detail', data);
}
export function contractPlanStop(data) {
  return request.post('admin/contract/stop', data);
}